// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t193 (12-oct-2026) · LO QUE TAPA EL TECLADO DEL MÓVIL
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Para que una ventana a pantalla completa (la de «Nueva cita» en el móvil, pages/Agenda.jsx · NuevaCitaModal) deje su
//  pie —los botones— JUSTO ENCIMA del teclado y no debajo.
//
//  POR QUÉ HACE FALTA. En el iPhone, y en Chrome de Android desde su versión 108, abrir el teclado NO encoge la página:
//  encoge solo la parte que se ve (`window.visualViewport`). Una ventana `position: fixed` de toda la altura se queda con
//  su pie debajo del teclado, y además el navegador puede desplazar la vista hacia arriba para enseñar el campo, con lo que
//  la barra de arriba de la ventana se sale por arriba.
//
//  LA CUENTA. Cuánto sobra ARRIBA (lo que el navegador ha desplazado la vista) y ABAJO (el teclado), en píxeles CSS de la
//  aplicación: divididos por el tamaño de letra del perfil (el `zoom` de <html>, B-868). La ventana deja esos dos huecos y
//  lo que queda es exactamente lo que se ve.
//    · Con menos de `minimo` abajo NO hay teclado: es la barra del navegador que aparece y desaparece. No se toca nada.
//    · Con la página AMPLIADA con los dedos (`escala` > 1) tampoco: lo que se ve es un trozo ampliado, no un teclado.
//    · Un dato que no es un número cuenta como que no hay nada (nunca devuelve NaN ni negativos).
//
//  Pura y sin React a propósito: las guardias la cargan de verdad (backend/routes/cita-nueva-en-el-movil.test.js).
export const TECLADO_MINIMO = 80

export function huecoDelTeclado({ altoVentana, altoVisible, arribaVisible = 0, escala = 1, zoom = 1, minimo = TECLADO_MINIMO } = {}) {
  const num = (x) => (x !== null && x !== '' && Number.isFinite(Number(x)) ? Number(x) : 0)
  const nada = { arriba: 0, abajo: 0 }
  const alto = num(altoVentana)
  const visible = num(altoVisible)
  if (!(alto > 0) || !(visible > 0)) return nada
  if (num(escala) > 1.05) return nada
  const arriba = Math.max(0, num(arribaVisible))
  const abajo = Math.max(0, alto - visible - arriba)
  if (abajo < num(minimo)) return nada
  const z = num(zoom) > 0 ? num(zoom) : 1
  return { arriba: Math.round(arriba / z), abajo: Math.round(abajo / z) }
}
